import { combineReducers } from 'redux';
import {
  UPDATE_REMAINING_DOWNLOADS,
  GENERATE_AI_PHOTO,
  GENERATE_AI_PHOTO_SUCCESS,
  GENERATE_AI_PHOTO_ERROR,
  DOWNLOAD_AI_PHOTO,
  DOWNLOAD_AI_PHOTO_SUCCESS,
  DOWNLOAD_AI_PHOTO_ERROR,
  DOWNLOAD_AI_PHOTO_IN_PROGRESS,
} from './constants';

export const initialState = {
  photo: {
    image_url:
      'https://jp.static.photo-ac.com/assets/img/ai_page/ai_model_512_01.png',
    property: {
      heigh: 256,
      width: 256,
      chanel: 3,
    },
  },
  loading: false,
  error: false,
  remainingDownloads: 0,
};

function aiPhotoReducer(state = initialState, action) {
  switch (action.type) {
    case GENERATE_AI_PHOTO:
      return {
        ...state,
        loading: true,
      };
    case GENERATE_AI_PHOTO_SUCCESS:
      return {
        ...state,
        photo: action.photo,
        loading: false,
      };
    case GENERATE_AI_PHOTO_ERROR:
      return { ...state, error: action.error, loading: false };
    case UPDATE_REMAINING_DOWNLOADS:
      return { ...state, remainingDownloads: action.payload };
    default:
      return state;
  }
}

export const initStateDownloadPhoto = {
  currentDownloadingPhotoURLs: [],
  loading: false,
  error: false,
};

function photoDownloadReducer(state = initStateDownloadPhoto, action) {
  switch (action.type) {
    case DOWNLOAD_AI_PHOTO:
      return {
        ...state,
        loading: true,
        currentDownloadingPhotoURLs: state.currentDownloadingPhotoURLs.concat(
          action.payload,
        ),
      };
    case DOWNLOAD_AI_PHOTO_SUCCESS:
      return {
        ...state,
        loading: false,
        currentDownloadingPhotoURLs: state.currentDownloadingPhotoURLs.filter(
          (photoURL) => photoURL !== action.payload,
        ),
      };

    case DOWNLOAD_AI_PHOTO_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
        downloading: false,
      };

    default:
      return state;
  }
}

export default combineReducers({
  detail: aiPhotoReducer,
  download: photoDownloadReducer,
});
